import axios from 'axios'
export const getAllShipment = (params) => {
  return axios.get('shipments', {
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/shipment.js